"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.twoWayData = exports.throwError = exports.assertNever = void 0;
var s_js_1 = require("s-js");
function assertNever(obj) {
    throw throwError("Unexpected obj: " + JSON.stringify(obj));
}
exports.assertNever = assertNever;
function throwError(msg) {
    var debugOutput = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        debugOutput[_i - 1] = arguments[_i];
    }
    console.error(msg, debugOutput);
    throw new Error(msg);
}
exports.throwError = throwError;
function twoWayData(value, pick, output) {
    var signal = s_js_1.default.data(pick(s_js_1.default.sample(value)));
    s_js_1.default.on(value, function () {
        // Just pass it through to signal. The S computation will resolve updates
        var incoming = pick(value());
        if (incoming !== s_js_1.default.sample(signal)) {
            signal(incoming);
        }
    }, undefined, true);
    s_js_1.default(function () {
        var propsData = s_js_1.default.sample(value); // avoid dependency on value
        var curr = signal();
        if (curr !== pick(propsData)) {
            value(__assign(__assign({}, propsData), output(curr)));
        }
    });
    return signal;
}
exports.twoWayData = twoWayData;
//# sourceMappingURL=util.js.map